module.exports = __webpack_public_path__ + "static/img/friend7.168ca69.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/friend7.png
// module id = XwV1
// module chunks = 1